import type { BgColors, Colors } from '../../../constants';
import type { MenuItemState } from './types';

export const menuItemBackgroundColor: Record<MenuItemState, BgColors> = {
  default: 'bg-ds-accent3-100',
  focus: 'bg-ds-natural-50',
  active: 'bg-ds-natural-100',
  disabled: 'bg-ds-accent3-100',
  selected: 'bg-ds-natural-100',
};

export const menuItemTextColor: Record<MenuItemState, Colors> = {
  default: 'text-ds-natural-600',
  focus: 'text-ds-natural-600',
  active: 'text-ds-natural-700',
  disabled: 'text-ds-natural-200',
  selected: 'text-ds-natural-700',
};
